<script>
export default {
  props: {
    news: {
      type: Object,
    },
  },
};
</script>

<template>
  <div>
    <router-link
      :to="{name: 'userpage', params: {type: 'profile', id: news.textParams[0]}}"
      class="member-name"
    >{{news.textParams[1]}}</router-link>
    {{$t('news.template.proposal.publishByMemberApproved.p1')}}
    <router-link
      :to="{name: 'ProposalView', params: {id: news.textParams[3]}}"
    >{{news.textParams[4]}}</router-link>
    {{$t('news.template.proposal.publishByMemberApproved.p2')}}
    <router-link :to="{name: 'forum', params: {id: news.textParams[5]}}"
    >{{news.textParams[6]}}</router-link>.
    <router-link :to="{name: 'forum', params: {id: news.textParams[5]}}"
    >{{news.textParams[6]}}</router-link>
    {{$t('news.template.proposal.publishByMemberApproved.p3')}}
    {{news.textParams[2]}}
    {{$t('news.template.proposal.publishByMemberApproved.p4')}}
    {{news.textParams[7]}}
    <router-link :to="{name: 'ProposalView', params: {id: news.textParams[3]}}">
      {{$t('news.template.proposal.publishByMemberApproved.p5')}}
    </router-link>
    {{$t('news.template.proposal.publishByMemberApproved.p6')}}
  </div>
</template>
